window.ApiService = {
  baseUrl: baseUrl,
  defaultHeaders: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },

  async _fetchWrapper(endpoint, options = {}) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        ...options,
        headers: {
          ...this.defaultHeaders,
          ...options.headers,
        },
      });
      if (!response.ok) throw new Error(`Error: ${response.statusText}`);
      return await response.json();
    } catch (error) {
      mostrarAlerta({
        title: "API Error:",
        error,
        text: "Error inesperado al procesar tu solicitud. Intenta de nuevo o contacta soporte..",
        confirmText: "Aceptar",
        url: "",
      });
      throw error;
    }
  },

 // Métodos específicos
    async getFormOptions(formId) {
      return this._fetchWrapper(`/forms/${formId}/options`);
    },
    
    async getPqrsOptions() {
      return this._fetchWrapper('/Generic/ConsultList?idParameter=1', {
        method: 'GET',
      });
    },
  
    async submitForm(data, formName) {
      return this._fetchWrapper(`/Customer/${formName}Request`, {
        method: 'POST',
        body: JSON.stringify(data)
      });
    },

  async getCustomerOrders(customerId) {
    return this._fetchWrapper(`/customers/${customerId}/orders`);
  },

  async getPqrsOptions() {
    return this._fetchWrapper("/Generic/ConsultList?idParameter=1");
  },

  async getFormOptions(formId) {
    return this._fetchWrapper(`/forms/${formId}/options`);
  },
  //Servicios de catalogo
  async serviceConsultCatalog({
    key = "",
    code = "",
    name = "",
    lastId = 0,
    vetFees = false,
  } = {}) {
    const params = new URLSearchParams();
    params.append("key", key);
    params.append("code", code);
    params.append("name", name);
    params.append("lastId", lastId);
    params.append("vetFees", vetFees);

    return this._fetchWrapper(`/ConsultExams?${params.toString()}`);
  },
  
  async serviceDetalleCatalog(idExam) {
    return this._fetchWrapper(`/ConsultTecnicalSheet?id=${idExam}`);
  },
  //Servicios de ordenes
  async getTypesDocuments() {
    return [
      { id: 1, code: "CC", name: "Cédula de Ciudadanía" },
      { id: 2, code: "TI", name: "Tarjeta de Identidad" },
      { id: 3, code: "PA", name: "Pasaporte" },
    ];
  },

  async getSexsPatient() {
    return [
      { id: 1, code: "M", name: "Masculino" },
      { id: 2, code: "F", name: "Femenino" },
      { id: 3, code: "I", name: "Intersexual" },
    ];
  },

  async getParcelServices() {
    return [
      { id: 1, code: "E1", name: "Envia" },
      { id: 2, code: "S1", name: "Servientrega" },
      { id: 3, code: "I1", name: "Interapidisimo" },
    ];
  },

  async getCompanyPlans() {
    return [
      { id: 1, code: "COD1", name: "Plan 1" },
      { id: 2, code: "COD2", name: "Plan 2" },
      { id: 3, code: "COD3", name: "Plan 3" },
      { id: 4, code: "COD4", name: "Plan 4" },
    ];
  },

  async getServicesOrder(plan_id) {
    const service1 = [
      { id: 1, code: "COD1", name: "Service 1", price: 1200 },
      { id: 2, code: "COD2", name: "Service 2", price: 1300 },
      { id: 3, code: "COD3", name: "Service 3", price: 1400 },
      { id: 4, code: "COD4", name: "Service 4", price: 1500 },
    ];
    const service2 = [
      { id: 1, code: "COD1", name: "Service1 1", price: 2200 },
      { id: 2, code: "COD2", name: "Service1 2", price: 2200 },
      { id: 3, code: "COD3", name: "Service1 3", price: 2200 },
      { id: 4, code: "COD4", name: "Service1 4", price: 2200 },
    ];
    return plan_id == "1" ? service1 : service2;
   },
    
  async getOrdersDetails(id_order){
     return  { 
      numOrder: '20250203001', 
      typeDoc: 'CURP', 
      numDoc: '5151615164', 
      names: 'Juan Carlos', 
      paternalSurname: 'Carvajal', 
      maternalSurname: 'Torres', 
      birdthDate: '05/07/1998', 
      age: '26 años 3 meses 1 días', 
      sex: 'Masculino', 
      datetimeSample: '2025/02/03 - 14:02', 
      parcel: 'FedEx', 
      numTicket: '8526263256', 
      pregnant: 'No aplica', 
      observations: 'Texto de la observación', 
      services: [ 
        { id: 1, key: 'P50', name: 'Chequeo general', price: '20', studies: [ { id: 1, key: 'P62', name: 'Frotis de sangre', price: '0' }, { id: 2, key: 'P62', name: 'Frotis de sangre', price: '0' } ] }, 
        { id: 1, key: 'H5613', name: 'Cuadro hémático', price: '15', studies: [] }, 
        { id: 1, key: 'H5613', name: 'Cuadro hémático', price: '36', studies: [] }, 
        { id: 1, key: 'H5613', name: 'Cuadro hémático', price: '8', studies: [] } 
      ] 
     };
   },

  async getTagsOrder() {
    return 0;
  },

  async userLogin(user_credentials) {
    return {
      token: "asdf8978asd6f78asd7f65a8sd7f68a"
    }
  },

  async testService() {
    console.log("Servicio Api inicializado correctamente");
    return "Servicio Api inicializado correctamente";
  },
};
